import ReactGA from 'react-ga4';
import type { Metric } from 'web-vitals';

export const sendWebVitalsToGoogleAnalytics = (metric: Metric) => {
    ReactGA.gtag('event', metric.name, {
        event_category: 'Web Vitals',
        value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
        event_label: metric.id,
        non_interaction: true,
    });
};
